import initExternalClasses from "./init-external-classes";
import initLocalClasses from "./init-local-classes";

/**
 * Immediate init element classes
 * @param {GlobalSingleTriggerProps} classes
 */
const initImmediateClasses = (classes) => {
  /** Loop trough them and fire the event */
  for (const [main, names] of classes) {
    for (const name of names) {
      const external = /** @type {Map<String, String>} */ (main.applied.get("class").get("external"));
      const local = /** @type {Map<String, String>} */ (main.applied.get("class").get("local"));

      /** Check for classes that are already applied on external target */
      initExternalClasses(main, external, name);

      /** Check for classes that are already applied on local element */
      initLocalClasses(main, local, name);

      main.isImmediate = true;
    }
  }
};

export default initImmediateClasses;
